import getCookie from './getCookie.ts';

export default function getCredentialsOptions(): RequestInit {
  const accessToken = getCookie('access-token');
  return {
    headers: new Headers({
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    })
  };
}
